/* su-bundle-game.js v2 — cosmetic "game layer" for the bundle builder (2026-06-11).
   Pure presentation: reads the builder's state via SUBundleGame.update(state)
   hooks placed in su-bundle-builder.liquid (updateProgress, selectGift,
   renderGiftStep). Touches NOTHING in the cart, discount, or step logic
   (see docs/BUNDLE-FLOW.md in socksup-agents repo).
   GPU-only animations (transform + opacity). RTL-safe. Reduced-motion aware.
   v2: tray follows onto the gift step, fly-to-tray pick animation,
   gift-slot nudge at 1-away, mobile compact sizing. */
(function () {
  'use strict';

  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var T = {
    save: AR ? 'وفّرتوا {amt} درهم' : 'You save {amt} AED',
    pickGift: AR ? 'اختاروا هديتكم 🎁' : 'Pick your gift 🎁',
    remove: AR ? 'إزالة {name}' : 'Remove {name}',
    popular: AR ? 'الأكثر اختياراً' : 'Popular pick',
    swap: AR ? 'اضغطوا على أي سوكس وبدّلوه' : 'Tap a pair to swap it'
  };

  /* 2026-09-29 (shopper panel G8, B4): the tray wraps, so the savings pill and the swap hint can take their own line on a
     phone; the remove mark is a small corner mark on every screen (it was a hover only overlay, so phones had no cue);
     slots are 44 px on phones, the theme's tap size. */
  var css = ''
    + '.su-game-tray{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin:14px 0 4px;}'
    + '.su-game-slots{display:flex;gap:8px;}'
    + '.su-game-bundle-chip{font-size:10px;font-weight:700;letter-spacing:.08em;background:var(--su-pistachio,#B5D67C);color:#2c3a1a;padding:3px 8px;border-radius:999px;white-space:nowrap;}'
    + '.su-game-slot{width:52px;height:52px;border-radius:14px;border:2px dashed var(--su-line,#E8E0D0);background:var(--su-cream-2,#F4EEE2);display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative;transition:border-color .2s;}'
    + '.su-game-slot--filled{border:2px solid var(--su-ink,#1A1A1A);}'
    + '.su-game-slot--gift{border-color:var(--su-butter,#F6C445);}'
    + '.su-game-slot img{width:100%;height:100%;object-fit:cover;}'
    + '.su-game-slot__ph{font-size:18px;opacity:.45;}'
    + '.su-game-slot--pop{animation:suGamePop .35s cubic-bezier(.34,1.56,.64,1);}'
    + '@keyframes suGamePop{0%{transform:scale(.4)}70%{transform:scale(1.12)}100%{transform:scale(1)}}'
    + '.su-game-slot--nudge{animation:suGameNudge 2.6s ease-in-out infinite;}'
    + '@keyframes suGameNudge{0%,86%,100%{transform:rotate(0)}88%{transform:rotate(-6deg)}91%{transform:rotate(6deg)}94%{transform:rotate(-4deg)}97%{transform:rotate(3deg)}}'
    + '.su-game-tray--giftstep .su-game-slot--gift{box-shadow:0 0 0 3px rgba(246,196,69,.35);}'
    + '.su-game-save{margin-inline-start:auto;font-family:"JetBrains Mono",monospace;font-size:12px;font-weight:600;background:var(--su-pistachio,#B5D67C);color:#2c3a1a;padding:6px 12px;border-radius:999px;opacity:0;transform:translateY(4px);transition:opacity .25s,transform .25s;white-space:nowrap;}'
    + '.su-game-save--on{opacity:1;transform:translateY(0);}'
    + '.su-game-tray--done .su-game-slots{animation:suGameDone .5s cubic-bezier(.34,1.56,.64,1);}'
    + '@keyframes suGameDone{0%{transform:scale(1)}40%{transform:scale(1.05)}100%{transform:scale(1)}}'
    + '.su-game-confetti{position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:1002;overflow:hidden;}'
    + '.su-game-confetti i{position:absolute;width:8px;height:12px;opacity:0;will-change:transform,opacity;}'
    + '.su-game-fly{position:fixed;z-index:1003;pointer-events:none;border-radius:12px;overflow:hidden;will-change:transform,opacity;}'
    + '.su-game-fly img{width:100%;height:100%;object-fit:cover;}'
    + '.su-game-slot--removable{cursor:pointer;-webkit-tap-highlight-color:transparent;}'
    + '.su-game-slot__x{position:absolute;top:2px;inset-inline-end:2px;width:16px;height:16px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:rgba(26,26,26,.82);color:#fff;font-size:10px;font-weight:700;line-height:1;pointer-events:none;}'
    + '@media (hover:hover) and (pointer:fine){.su-game-slot--removable:hover{transform:scale(1.06);transition:transform .15s;}.su-game-slot--removable:hover .su-game-slot__x{background:#C4321C;}}'
    + '.su-game-caption{display:none;flex-basis:100%;margin:0;font-size:13px;font-weight:600;line-height:1.35;color:var(--su-ink,#1A1A1A);}'
    + '.su-game-tray--giftstep .su-game-caption{display:block;}'
    + '.su-game-tray.su-game-tray--giftstep{margin-bottom:18px;}'   /* the tilted FREE tapes on the first gift row reach up about 12 px */
    + '.su-game-popular{position:absolute;top:8px;inset-inline-start:8px;z-index:2;background:var(--su-butter,#F6C445);color:#1A1A1A;font-family:"JetBrains Mono",monospace;font-size:9px;font-weight:700;letter-spacing:.06em;padding:4px 8px;border-radius:999px;pointer-events:none;}'
    + '@media (max-width:749px){'
    +   '.su-game-tray{gap:8px;margin:10px 0 2px;}'
    +   '.su-game-slots{gap:6px;}'
    +   '.su-game-slot{width:44px;height:44px;border-radius:11px;}'
    +   '.su-game-slot__ph{font-size:14px;}'
    +   '.su-game-save{font-size:11px;padding:5px 10px;}'
    + '}'
    + '@media (prefers-reduced-motion: reduce){.su-game-slot--pop,.su-game-slot--nudge,.su-game-tray--done .su-game-slots{animation:none;}}';

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  var tray = null, slotEls = [], saveEl = null;
  var prevCount = 0, prevGift = false, celebrated = false;
  var lastTileClick = null; /* {src, rect, t} for fly-to-tray */

  /* Fly-to-tray: passive observation of tile clicks — no logic interference.
     Every click also re-places the tray shortly after, so it follows step
     transitions (claim gift / back / edit) without hooking the step logic. */
  document.addEventListener('click', function (e) {
    /* Mega Box panel has no tray/fly animation — skip so its 24-tap flow
       never pays this listener's getBoundingClientRect reflow. */
    if (e.target && e.target.closest && e.target.closest('#MegaPanel')) return;
    if (tray) setTimeout(function () { placeTray(); decoratePopular(); }, 400);
    var tile = e.target && e.target.closest && e.target.closest('.su-bundle__tile');
    if (!tile || tile.classList.contains('is-selected') || tile.classList.contains('is-soldout')) return;
    var img = tile.querySelector('img');
    if (!img || !img.src) return;
    lastTileClick = { src: img.src, rect: img.getBoundingClientRect(), t: Date.now() };
  }, true);

  function buildTray(size) {
    tray = document.createElement('div');
    tray.className = 'su-game-tray';
    tray.setAttribute('aria-hidden', 'true');
    var chip = document.createElement('span');
    chip.className = 'su-game-bundle-chip su-mono';
    chip.id = 'SuGameBundleChip';
    chip.hidden = true;
    tray.appendChild(chip);
    var slots = document.createElement('div');
    slots.className = 'su-game-slots';
    slotEls = [];
    for (var i = 0; i < size + 1; i++) {
      var s = document.createElement('div');
      s.className = 'su-game-slot' + (i === size ? ' su-game-slot--gift' : '');
      s.innerHTML = '<span class="su-game-slot__ph">' + (i === size ? '🎁' : '🧦') + '</span>';
      slots.appendChild(s);
      slotEls.push(s);
    }
    saveEl = document.createElement('div');
    saveEl.className = 'su-game-save';
    tray.appendChild(slots);
    tray.appendChild(saveEl);
    /* shown on the gift wall only (CSS on .su-game-tray--giftstep) */
    var caption = document.createElement('p');
    caption.className = 'su-game-caption';
    caption.textContent = T.swap;
    tray.appendChild(caption);
    wireSlotRemoval();
  }

  /* The tray follows the customer: pick step (above progress bar) → gift step
     (above the gift grid). Re-appending moves the single element. */
  function placeTray() {
    var fill = document.getElementById('BundleProgFill');
    var pickAnchor = fill && (fill.closest('.su-bundle__progress-wrap') || fill.closest('.su-bundle__progress-track'));
    var giftGrid = document.getElementById('BundleGiftGrid');
    var giftVisible = giftGrid && giftGrid.offsetParent !== null;
    var pickVisible = pickAnchor && pickAnchor.offsetParent !== null;

    var target = null, mode = '';
    if (pickVisible) { target = pickAnchor; mode = 'pick'; }
    else if (giftVisible) { target = giftGrid; mode = 'gift'; }
    if (!target) return false;

    if (tray.nextElementSibling !== target || tray.parentNode !== target.parentNode) {
      target.parentNode.insertBefore(tray, target);
    }
    tray.classList.toggle('su-game-tray--giftstep', mode === 'gift');
    return true;
  }

  function fillSlot(el, imgSrc, pop, removable) {
    if (!el) return;
    el.classList.add('su-game-slot--filled');
    if (imgSrc) el.innerHTML = '<img src="' + imgSrc + '" alt="" loading="lazy" decoding="async">';
    if (removable) {
      el.classList.add('su-game-slot--removable');
      var x = document.createElement('span');
      x.className = 'su-game-slot__x';
      x.textContent = '✕';
      el.appendChild(x);
    } else {
      el.classList.remove('su-game-slot--removable');
    }
    if (pop && !REDUCED) {
      el.classList.remove('su-game-slot--pop');
      void el.offsetWidth;
      el.classList.add('su-game-slot--pop');
    }
  }

  /* Tap a filled slot to un-pick. Multi-pick (2026-07-06) made tile.click()
     ADD a copy instead of toggling off, so removal goes through the builder's
     exposed remove hook; tile.click() stays only as a legacy fallback.
     2026-09-29 (shopper panel G8, B4): on the gift wall the tap is a swap. The builder takes that pair out and opens the
     picker at 3 of 4, so the shopper picks its replacement; it used to take the pair out silently and leave a 3 pair box. */
  function wireSlotRemoval() {
    slotEls.forEach(function (el, i) {
      el.addEventListener('click', function () {
        var pid = el.dataset.pid;
        if (!pid) return;
        if (tray && tray.classList.contains('su-game-tray--giftstep') && typeof window.suBundleSwapOne === 'function') {
          window.suBundleSwapOne(pid);
          return;
        }
        if (typeof window.suBundleRemoveOne === 'function') {
          window.suBundleRemoveOne(pid);
          return;
        }
        var tile = document.querySelector('#BundleGrid .su-bundle__tile[data-product-id="' + pid + '"]');
        if (tile && tile.classList.contains('is-selected')) tile.click();
      });
    });
  }

  /* First 3 grid tiles = top sellers (collections are sorted BEST_SELLING). */
  function decoratePopular() {
    var grid = document.getElementById('BundleGrid');
    if (!grid || grid.offsetParent === null) return;
    var tiles = grid.querySelectorAll('.su-bundle__tile');
    var done = 0;
    for (var i = 0; i < tiles.length && done < 3; i++) {
      var t = tiles[i];
      if (t.classList.contains('is-soldout')) continue;
      if (!t.querySelector('.su-game-popular')) {
        var b = document.createElement('span');
        b.className = 'su-game-popular';
        b.textContent = T.popular;
        if (getComputedStyle(t).position === 'static') t.style.position = 'relative';
        t.appendChild(b);
      }
      done++;
    }
  }

  function emptySlot(el, isGift) {
    if (!el) return;
    el.classList.remove('su-game-slot--filled');
    el.classList.remove('su-game-slot--removable');
    el.innerHTML = '<span class="su-game-slot__ph">' + (isGift ? '🎁' : '🧦') + '</span>';
  }

  function flyToSlot(slotEl) {
    if (REDUCED || !lastTileClick || Date.now() - lastTileClick.t > 900) return;
    var from = lastTileClick.rect;
    var to = slotEl.getBoundingClientRect();
    if (!to.width) return;
    var ghost = document.createElement('div');
    ghost.className = 'su-game-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    ghost.innerHTML = '<img src="' + lastTileClick.src + '" alt="">';
    document.body.appendChild(ghost);
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    var scale = to.width / from.width;
    ghost.animate(
      [
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 0.95 },
        { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + scale + ')', opacity: 0.4 }
      ],
      { duration: 420, easing: 'cubic-bezier(.3,.8,.4,1)', fill: 'forwards' }
    ).onfinish = function () { ghost.remove(); };
    lastTileClick = null;
  }

  var countUpRaf = null;
  function animateSave(toAmt) {
    if (!saveEl) return;
    if (toAmt <= 0) { saveEl.classList.remove('su-game-save--on'); return; }
    saveEl.classList.add('su-game-save--on');
    if (REDUCED) { saveEl.textContent = T.save.replace('{amt}', toAmt); return; }
    var from = parseInt(saveEl.dataset.amt || '0', 10) || 0;
    if (from === toAmt) { saveEl.textContent = T.save.replace('{amt}', toAmt); return; }
    var t0 = null;
    if (countUpRaf) cancelAnimationFrame(countUpRaf);
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min((ts - t0) / 450, 1);
      var v = Math.round(from + (toAmt - from) * (1 - Math.pow(1 - k, 3)));
      saveEl.textContent = T.save.replace('{amt}', v);
      if (k < 1) countUpRaf = requestAnimationFrame(step);
    }
    countUpRaf = requestAnimationFrame(step);
    saveEl.dataset.amt = String(toAmt);
  }

  function confetti() {
    if (REDUCED) return;
    var colors = ['#F6C445', '#B5D67C', '#F7B8B0', '#9BCFE8', '#C8B6E2', '#C4321C'];
    var wrap = document.createElement('div');
    wrap.className = 'su-game-confetti';
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('i');
      p.style.background = colors[i % colors.length];
      p.style.left = (8 + Math.random() * 84) + '%';
      p.style.top = '-16px';
      p.style.borderRadius = (i % 3 === 0) ? '50%' : '2px';
      var fall = 55 + Math.random() * 35;
      var drift = (Math.random() - 0.5) * 30;
      var rot = 360 + Math.random() * 540;
      var dur = 1100 + Math.random() * 700;
      p.animate(
        [
          { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 },
          { transform: 'translate3d(' + drift + 'vw,' + fall + 'vh,0) rotate(' + rot + 'deg)', opacity: 0 }
        ],
        { duration: dur, easing: 'cubic-bezier(.2,.6,.4,1)', delay: Math.random() * 180, fill: 'forwards' }
      );
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 2400);
  }

  window.SUBundleGame = {
    /* opts.quiet (2026-09-30): the builder redraws the tray after following the cart (a box edited in the drawer), with no
       fly, pop, "done" bounce or confetti; a pick still gets all of them */
    update: function (state, opts) {
      var quiet = !!(opts && opts.quiet);
      try {
        var _chip = document.getElementById('SuGameBundleChip');
        if (_chip) {
          var _n = (state && state.bundleCount) ? state.bundleCount + 1 : 0;
          if (_n >= 2) {
            var _tpl = (window.SU_I18N && SU_I18N.bundles_bundle_n) || 'Bundle [[n]]';
            _chip.textContent = _tpl.split('[[n]]').join(_n);
            _chip.hidden = false;
          } else { _chip.hidden = true; }
        }
      } catch (e) {}

      if (!state) return;
      var size = state.size || 4;
      if (!tray) buildTray(size);
      if (!placeTray()) return;

      var picked = state.picked || [];
      var newlyPicked = !quiet && picked.length > prevCount;
      for (var i = 0; i < size; i++) {
        if (picked[i]) {
          var isNewest = newlyPicked && i === picked.length - 1;
          if (isNewest) flyToSlot(slotEls[i]);
          fillSlot(slotEls[i], picked[i].image, isNewest, true);
          slotEls[i].dataset.pid = picked[i].id;
          slotEls[i].setAttribute('aria-label', T.remove.replace('{name}', picked[i].title || ''));
        } else {
          emptySlot(slotEls[i], false);
          delete slotEls[i].dataset.pid;
          slotEls[i].removeAttribute('aria-label');
        }
      }
      decoratePopular();

      var giftSlot = slotEls[size];
      if (state.gift) {
        if (!prevGift) { if (!quiet) flyToSlot(giftSlot); fillSlot(giftSlot, state.gift.image, !quiet); }
        giftSlot.classList.remove('su-game-slot--nudge');
      } else {
        if (prevGift) emptySlot(giftSlot, true);
        /* "so close" nudge: 1 pick away from completing the pack */
        giftSlot.classList.toggle('su-game-slot--nudge', picked.length === size - 1 || (picked.length === size && !state.gift));
      }

      var regular = picked.reduce(function (a, p) { return a + (p.price || 0); }, 0) / 100;
      var saved = Math.max(0, Math.round(regular + (state.gift ? (state.gift.price || 0) / 100 : 0) - (state.price || 100)));
      animateSave(picked.length >= size ? saved : 0);

      if (picked.length === size && prevCount < size && quiet) celebrated = true;
      else if (picked.length === size && prevCount < size) {
        tray.classList.add('su-game-tray--done');
        if (!celebrated) { confetti(); celebrated = true; }
        setTimeout(function () { tray && tray.classList.remove('su-game-tray--done'); }, 600);
      }
      if (picked.length < size) celebrated = false;

      prevCount = picked.length;
      prevGift = !!state.gift;

      /* Step transitions reveal containers AFTER the render hooks run —
         re-place once the new step is actually visible. */
      setTimeout(placeTray, 350);
    }
  };
})();
